import { render } from "./PaywallSubscriptionDetails.vue?vue&type=template&id=5c51982e&scoped=true"
import script from "./PaywallSubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./PaywallSubscriptionDetails.vue?vue&type=script&lang=js"

import "./PaywallSubscriptionDetails.vue?vue&type=style&index=0&id=5c51982e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c51982e"],['__file',"src/components/ui/PaywallSubscriptionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c51982e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c51982e', __exports__)) {
    api.reload('5c51982e', __exports__)
  }
  
  module.hot.accept("./PaywallSubscriptionDetails.vue?vue&type=template&id=5c51982e&scoped=true", () => {
    api.rerender('5c51982e', render)
  })

}


export default __exports__